import { generateKeys } from '../utils';
export const bannerStatuses = generateKeys({
    draft: {
        value: 'draft',
        label: 'Draft',
    },
    active: {
        value: 'active',
        label: 'Active',
    },
    inactive: {
        value: 'inactive',
        label: 'Inactive',
    },
});
export const bannerType = generateKeys({
    web: {
        value: 'web',
        label: 'Web',
    },
    mobile: {
        value: 'mobile',
        label: 'Mobile',
    },
});
